import { io, Socket } from 'socket.io-client';

const socket: Socket = io('', {
    reconnection: true,
    reconnectionDelay: 500
});

const getSocketIo = (): Socket => socket;

export { getSocketIo };
